<template>
    <div class="responder">
        <div class="responder__image">
            <img :src="responder.image" class="responder__image__main-image mb-3 mb-md-0" />
            <img v-if="responder.type === 'pharmacist'" src="/nuxt-assets/icons/pharmacist-icon.svg" class="responder__image__icon" />
        </div>
        <div class="responder__right">
            <div class="responder__title">{{ $t('counselling.questionIsAnsweredBy') }}</div>
            <h2 class="responder__name">{{ responder.name }}</h2>
            <div class="responder__job-position">{{ responder.jobPosition }}</div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { PropType } from 'vue'
import PaperAuthor from '~/models/StaticContent/Article/PaperAuthor'

const props = defineProps({
    responder: {
        type: Object as PropType<PaperAuthor>,
        required: true,
    },
})
const { responder } = toRefs(props)
</script>

<style lang="scss" scoped>
.responder {
    display: grid;
    grid-template-columns: 50px auto;
    grid-gap: 22px;
    align-items: center;

    &__right {
        padding-right: 15px;
    }

    &__image {
        height: 50px;
        position: relative;

        &__main-image {
            border-radius: 100%;
            width: 50px;
            height: 50px;
            object-fit: cover;
        }

        &__icon {
            position: absolute;
            bottom: -5px;
            right: -5px;
        }
    }

    &__title {
        color: $color-grey-extra-dark;
        font-size: 12px;
        font-weight: 400;
        margin-bottom: 6px;
    }

    &__name {
        color: $color-dark;
        font-size: 16px;
        font-weight: 590;
        margin-bottom: 6px;
    }

    &__job-position {
        color: $color-grey-extra-dark;
        font-size: 12px;
        font-weight: 590;
    }
}
</style>
